module.exports = __webpack_public_path__ + "img/preloader-sprite.830ad8.svg";